import PlayerPrevious from './src/player-previous-combined';
export default PlayerPrevious;